import { useMemo } from 'react';
import { formatSnakeCaseToGeneral } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import { capitalize } from 'lodash';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';

import { AuthorizedUser } from '../../../authorizedUsers.types';

export const COLUMNS = [
  { key: 'firstName', title: 'First name', flex: '1' as const },
  { key: 'lastName', title: 'Last name', flex: '1' as const },
  { key: 'relationship', title: 'Relationship', flex: '1' as const },
  { key: 'dateOfBirth', title: 'Date of birth', flex: '1' as const },
  { key: 'actions', title: 'Actions', flex: '0 0 130px' as const },
];

export interface FormattedAuthorizedUser {
  id: string;
  firstName: string;
  lastName: string;
  relationship: string;
  dateOfBirth: string;
  onEdit: () => void;
  onDeactivate: () => void;
}

interface Props {
  authorizedUsers: AuthorizedUser[];
  onEdit: (user: AuthorizedUser) => void;
  onDeactivate: (id: string) => void;
}

const useAuthorizedUsersList = ({ authorizedUsers, onEdit, onDeactivate }: Props) => {
  const formattedUsers = useMemo<FormattedAuthorizedUser[]>(
    () =>
      authorizedUsers.map((user) => ({
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        relationship: capitalize(formatSnakeCaseToGeneral(user.relationshipType ?? '')),
        dateOfBirth: user.birthOn ? dayjs(user.birthOn).format(DEFAULT_DATE_FORMAT) : '-',
        onEdit: () => onEdit(user),
        onDeactivate: () => onDeactivate(user.id),
      })),
    [authorizedUsers, onEdit, onDeactivate]
  );

  return { formattedUsers };
};

export default useAuthorizedUsersList;
